import { AgencyId, SuretyAccountId, toISODateTime, UserId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DateTime } from "luxon";
import { useRequest } from "../../../utils/request";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountQueryKey } from "../account.keys";

export const useAdminBrokerOfRecordAccount = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({
			agencyId,
			effectiveDate,
			followerUserId,
		}: {
			agencyId: AgencyId;
			effectiveDate: string;
			followerUserId: UserId;
			onSuccess?: () => void;
		}) => {
			await post(
				`/v2/admin/surety/accounts/${accountId}/broker-of-record`,
				{
					agencyId,
					effectiveDate: toISODateTime(DateTime.fromISO(effectiveDate, { zone: "utc" })),
					agentUserId: followerUserId,
				},
				"none",
			);
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
			]);
		},
		onSuccess: (_, { onSuccess }) => {
			onSuccess?.();
		},
	});

	return {
		brokerOfRecordAccount: mutation.mutate,
		brokerOfRecordAccountError: mutation.error,
		brokerOfRecordAccountLoading: mutation.isPending,
		dismissBrokerOfRecordAccountError: () => {
			mutation.reset();
		},
	};
};
